module.exports = __webpack_public_path__ + "img/page4.d557d85d.png";